import { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import {
  calculator,
  DashingCreditCard,
  formatNumberWithCurrency,
  TComma
} from '../../../base/utils';
import { Note, Page } from '../../../helbest';
import { API } from '../../../request/api';
import { _logout_user, _set_i_user } from '../../../store/actions/login_actions';

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      credit_list: [],
      loading: true,
      credit_card: '-',
      nid: '-'
    };
    this.check_user();
  }

  check_user() {
    const { Login, history } = this.props;
    if (!Login.is_login) {
      history.push('/login/d/');
    }
  }

  _GET_I() {
    const { dispatch } = this.props;
    API.get
      .editProfile()
      .then((response) => {
        if (response.success) {
          dispatch(
            _set_i_user({
              phone_number: response.data.username,
              token: response.data.token,
              first_name: response.data.first_name,
              last_name: response.data.last_name,
              credit: response.data.credit
            })
          );
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  }

  componentDidMount() {
    const { dispatch, Login, historyhistory } = this.props;
    // Get Data
    API.get
      .editProfile()
      .then((response) => {
        if (response.code === 200) {
          this.setState({
            nid: response.data.national_id,
            credit_card: response.data.credit_card
          });
        } else if (
          response.message.toLowerCase().includes('invalid') ||
          response.message.toLowerCase().includes('token')
        ) {
          let carfilloData = localStorage.getItem('carfillo');
          if (carfilloData) {
            carfilloData = JSON.parse(carfilloData);
            delete carfilloData.Login;
            carfilloData = JSON.stringify(carfilloData);
            localStorage.setItem('carfillo', carfilloData);
          }
          dispatch(_logout_user());
          calculator();
          if (Login.login_required) {
            historyhistory.push('/login/d');
          } else {
            historyhistory.push('/');
          }
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
    this._GET_I();
  }

  render() {
    const { Login } = this.props;
    const { nid, credit_card } = this.state;
    return (
      <Page
        address="/"
        back={true}
        className="page-profile"
        headerFix
        logo
        mobileContainer
        showFooter
        title="حساب کاربری">
        <div className="profile-data-box-container container desktop-mode">
          <div className="profile-data-box">
            <div className="profile-title-flex">
              <h4 className="  red font-16">اطلاعات شخصی</h4>
              <div>
                <Link className="edit-btn-profile" to="/profile/edit/">
                  اصلاح اطلاعات
                </Link>
              </div>
            </div>
            <hr className="mar-t-5 mar-b-5" />
            <div className="profile-data-body  ">
              <div className="row">
                <div className="col-sm-12 profile-data-body-line">
                  <span> نام </span>
                  <span> {Login.first_name || '-'} </span>
                </div>
                <div className="col-sm-12 profile-data-body-line">
                  <span> نام خانوادگی </span>
                  <span> {Login.last_name || '-'} </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 profile-data-body-line">
                  <span> اعتبار حساب </span>
                  <span>{formatNumberWithCurrency(TComma(Login.credit))}</span>
                </div>
                <div className="col-sm-12 profile-data-body-line">
                  <span> شماره همراه </span>
                  <span> {Login.user.phone_number} </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 profile-data-body-line">
                  <span> کد ملی </span>
                  <span> {nid || '-'} </span>
                </div>
                <div className="col-sm-12 profile-data-body-line">
                  <span> شماره کارت </span>
                  <span className="profile-data-credit-card">{DashingCreditCard(credit_card)}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="row-profile-btn">
            <Link to="/credit/">لیست تراکنش اعتبار</Link>
            <Link to="/orders/">سفارشات</Link>
          </div>

          <div className="row-profile-btn">
            <Link to="/address/p/">آدرس‌ها</Link>
            <Link to="/otps/">کدهای یکبار مصرف</Link>
          </div>
        </div>
      </Page>
    );
  }
}

const mstp = (state) => ({
  Login: state.Login
});
export default withRouter(connect(mstp)(Profile));
